var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprinklerStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 41.9,
    viewBox: "0 0 42 41.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_359",
    x: 0,
    y: 0,
    width: 42,
    height: 37.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_13",
    x: 7.607,
    y: 16.4,
    width: 26.958,
    height: 25.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STRIP_SPRINKLER",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_359)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_359-2",
    "data-name": "Pfad 359",
    fill: "#f5f5f5",
    d: "M0,0V31.2H11v-2H2V2H34V29.2H25v2H36V0Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_13)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_13-2",
    "data-name": "Vereinigungsmenge 13",
    className: "cls-1",
    d: "M5033.985-2852.7a5.8,5.8,0,0,1,5.8-5.8,5.8,5.8,0,0,1,5.8,5.8,5.8,5.8,0,0,1-5.8,5.8A5.8,5.8,0,0,1,5033.985-2852.7Zm2,.1a3.8,3.8,0,0,0,3.8,3.8,3.8,3.8,0,0,0,3.8-3.8,3.8,3.8,0,0,0-3.8-3.8A3.8,3.8,0,0,0,5035.985-2852.6Zm1.7,0a2.112,2.112,0,0,1,2.1-2.1,2.112,2.112,0,0,1,2.1,2.1,2.051,2.051,0,0,1-2.1,2.1A2.112,2.112,0,0,1,5037.685-2852.6Zm6.721-6.052,1.484-1.486,1.485,1.486-1.485,1.484Zm-12.114-.037,1.485-1.484,1.484,1.484-1.484,1.486Zm-2.9-2.9,1.484-1.486,1.485,1.486-1.485,1.484Zm17.988-.031,1.484-1.485,1.485,1.485-1.485,1.484Zm-8.6,1.422v-2.1h2.1v2.1Zm0-4.1v-2.1h2.1v2.1Z",
    transform: "translate(-5018.79 2885.8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinklerStrip);
export default __webpack_public_path__ + "static/media/sprinkler-strip.ac1776090f7bc88ff099c45e023c5dcb.svg";
export { ForwardRef as ReactComponent };